'use strict';

angular.module('app.addNewInfluencerGroup', [])
	.factory('addNewInfluencerGroupService', ['$q', '$http', '$rootScope',
        function ($q, $http, $rootScope) {
            var service = {};

            function checkResponse(data) {
              return data;
            }

            function getMessage(data) {
              if (data) {
                return data.message;
              }
              return false;
            }

            function handleRequest(url, method, params, loader) {
                var deferred = $q.defer();

                var req = {
                    url: url,
                    method: method,
                    data: JSON.stringify(params),
                    loader: loader
                } 

                $http(req)
                    .success(function (data) {
                    var dataRes = angular.fromJson(data);

                    if (checkResponse(dataRes)) {
                        deferred.resolve(dataRes);
                    } else {
                        deferred.reject(getMessage(dataRes));
                    }
                })
                    .error(function (error) {
                        deferred.reject(error);
                    });

                return deferred.promise;
            }

            function getInfluencerGroupTypes(loader) {
                var url = $rootScope.apiUrl + 'influencerGroup/getInfluencerGroupTypes';
                return handleRequest(url, 'GET', null, loader);
            }

            function addNewInfluencerGroup(params, loader) {
                var url_addNewInfluencerGroup = $rootScope.apiUrl + 'influencerGroup/addNewInfluencerGroup';
                return handleRequest(url_addNewInfluencerGroup, 'POST', params, loader);
            }

            function updateInfluencerGroup(params, loader) {
                var url_updateInfluencerGroup = $rootScope.apiUrl + 'influencerGroup/updateInfluencerGroup';
                return handleRequest(url_updateInfluencerGroup, 'POST', params, loader);
            }

            function getInfluencerGroupDetails(influencer_group_id, loader) {
                var url_getInfluencerGroupDetails = $rootScope.apiUrl + 'influencerGroup/getInfluencerGroupDetails?influencer_group_id=' + influencer_group_id;
                return handleRequest(url_getInfluencerGroupDetails, 'GET', null, loader);
            }

            service.getInfluencerGroupTypes = getInfluencerGroupTypes;
            service.addNewInfluencerGroup = addNewInfluencerGroup;
            service.updateInfluencerGroup = updateInfluencerGroup;
            service.getInfluencerGroupDetails = getInfluencerGroupDetails;

            return service;
        }
    ])